import { render, staticRenderFns } from "./McmConfirmButton.vue?vue&type=template&id=2ceb90ed&scoped=true&"
import script from "./McmConfirmButton.vue?vue&type=script&lang=ts&"
export * from "./McmConfirmButton.vue?vue&type=script&lang=ts&"
import style0 from "./McmConfirmButton.vue?vue&type=style&index=0&id=2ceb90ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb90ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
